/** Query/body view=card nas listagens do Board (Em aberto + batch). */
export const BOARD_ORDERS_LIST_VIEW = 'card';
/** Listagem completa (default sem view / fallback). Detalhe do modal não usa isto. */
export const BOARD_ORDERS_FULL_VIEW = 'full';

export function withBoardOrdersListView(url) {
  const base = String(url || '');
  const join = base.includes('?') ? '&' : '?';
  return `${base}${join}view=${BOARD_ORDERS_LIST_VIEW}`;
}

export function isBoardCardOrder(ordem) {
  return ordem && typeof ordem === 'object' && ordem._boardView === 'card';
}
